import React, { useState, useEffect } from 'react';
import { ChevronLeft, ChevronRight, X, Phone, Calendar as CalendarIcon, User, Plus, Clock } from 'lucide-react';

const Calendar = () => {
  const [currentDate, setCurrentDate] = useState(new Date());
  const [appointments, setAppointments] = useState([]);
  const [selectedAppointment, setSelectedAppointment] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [showAddModal, setShowAddModal] = useState(false);
  const [showListModal, setShowListModal] = useState(false);
  const [selectedDayAppointments, setSelectedDayAppointments] = useState([]);
  const [selectedDate, setSelectedDate] = useState(null);
  const [patients, setPatients] = useState([]);
  const [formData, setFormData] = useState({
    patient_id: '',
    appointment_time: '',
    notes: '',
    direction: 'maestro',
    location: 'tibbiyot_dunyosi'
  });
  const [isNewPatient, setIsNewPatient] = useState(false);
  const [newPatientData, setNewPatientData] = useState({
    name: '',
    phone: '',
    birth_date: '',
    notes: ''
  });
  const [isEditingPatient, setIsEditingPatient] = useState(false);
  const [editingPatientData, setEditingPatientData] = useState({
    name: '',
    phone: '',
    birth_date: '',
    notes: ''
  });
  const [isEditingAppointment, setIsEditingAppointment] = useState(false);
  const [editingAppointmentData, setEditingAppointmentData] = useState({
    appointment_time: '',
    direction: '',
    location: '',
    notes: ''
  });
  const [inactiveDays, setInactiveDays] = useState([]);
  const [showInactiveModal, setShowInactiveModal] = useState(false);
  const [inactiveFormData, setInactiveFormData] = useState({
    inactive_date: '',
    reason: '',
    custom_reason: '',
    useCustomReason: false
  });

  useEffect(() => {
    fetchAppointments();
    fetchPatients();
    fetchInactiveDays();
  }, []);

  const fetchAppointments = () => {
    fetch('/api/appointments')
      .then(res => res.json())
      .then(data => {
        console.log('Записи для календаря:', data);
        setAppointments(data);
      });
  };

  const fetchPatients = () => {
    fetch('/api/patients')
      .then(res => res.json())
      .then(data => {
        setPatients(data);
      });
  };

  const fetchInactiveDays = () => {
    fetch('/api/inactive-days')
      .then(res => res.json())
      .then(data => {
        setInactiveDays(data);
      })
      .catch(error => {
        console.error('Ошибка при загрузке неактивных дней:', error);
      });
  };

  const getDaysInMonth = (date) => {
    const year = date.getFullYear();
    const month = date.getMonth();
    const daysInMonth = new Date(year, month + 1, 0).getDate();
    const firstDayOfMonth = new Date(year, month, 1).getDay();
    
    // Преобразуем день недели: 0 (воскресенье) -> 6, 1 (понедельник) -> 0, и т.д.
    // Это нужно для того, чтобы календарь начинался с понедельника
    const adjustedFirstDay = firstDayOfMonth === 0 ? 6 : firstDayOfMonth - 1;
    
    const days = [];
    for (let i = 0; i < adjustedFirstDay; i++) {
      days.push(null);
    }
    for (let i = 1; i <= daysInMonth; i++) {
      days.push(new Date(year, month, i));
    }
    return days;
  };

  const getAppointmentsForDate = (date) => {
    if (!date) return [];
    const dateStr = getLocalDateString(date);
    const filtered = appointments.filter(apt => apt.appointment_date === dateStr);
    console.log(`Записи на ${dateStr}:`, filtered);
    return filtered;
  };

  const getInactiveDaysForDate = (date) => {
    if (!date) return [];
    const dateStr = getLocalDateString(date);
    return inactiveDays.filter(day => day.inactive_date === dateStr);
  };

  const handleAppointmentClick = (appointment) => {
    setSelectedAppointment(appointment);
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setSelectedAppointment(null);
    setIsEditingPatient(false);
    setEditingPatientData({
      name: '',
      phone: '',
      birth_date: '',
      notes: ''
    });
    setIsEditingAppointment(false);
    setEditingAppointmentData({
      appointment_time: '',
      direction: '',
      notes: ''
    });
  };

  const handleDayClick = (day) => {
    if (day) {
      const inactiveDaysForDate = getInactiveDaysForDate(day);
             if (inactiveDaysForDate.length > 0) {
         return;
       }
      
      setSelectedDate(day);
      setShowAddModal(true);
      setFormData({
        patient_id: '',
        appointment_time: '',
        notes: ''
      });
    }
  };

  const closeAddModal = () => {
    setShowAddModal(false);
    setSelectedDate(null);
    setFormData({
      patient_id: '',
      appointment_time: '',
      notes: '',
      direction: 'maestro'
    });
    setIsNewPatient(false);
    setNewPatientData({
      name: '',
      phone: '',
      birth_date: '',
      notes: ''
    });
  };

  const handleShowMoreClick = (appointments, day, e) => {
    e.stopPropagation();
    setSelectedDayAppointments(appointments);
    setSelectedDate(day);
    setShowListModal(true);
  };

  const closeListModal = () => {
    setShowListModal(false);
    setSelectedDayAppointments([]);
  };

  const handleInactiveDayClick = (day) => {
    if (day) {
      setInactiveFormData({
        inactive_date: getLocalDateString(day),
        reason: '',
        custom_reason: '',
        useCustomReason: false
      });
      setShowInactiveModal(true);
    }
  };

  const closeInactiveModal = () => {
    setShowInactiveModal(false);
    setInactiveFormData({
      inactive_date: '',
      reason: '',
      custom_reason: '',
      useCustomReason: false
    });
  };

  const handleInactiveSubmit = (e) => {
    e.preventDefault();
    
    const user = JSON.parse(localStorage.getItem('user'));
    if (!user) {
      return;
    }

    // Если выбрана произвольная причина, используем её вместо reason
    const finalReason = inactiveFormData.useCustomReason ? inactiveFormData.custom_reason : inactiveFormData.reason;
    
    if (!finalReason.trim()) {
      return;
    }

    fetch('/api/inactive-days', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        inactive_date: inactiveFormData.inactive_date,
        reason: inactiveFormData.useCustomReason ? 'Произвольная причина' : inactiveFormData.reason,
        custom_reason: inactiveFormData.useCustomReason ? inactiveFormData.custom_reason : inactiveFormData.custom_reason,
        created_by: user.id
      })
    })
    .then(response => {
      if (!response.ok) {
        throw new Error('Ошибка при создании неактивного дня');
      }
      return response.json();
    })
    .then(data => {
      console.log('Неактивный день создан:', data);
      fetchInactiveDays();
      closeInactiveModal();
    })
    .catch(error => {
      console.error('Ошибка:', error);
    });
  };

  const handleActivateDay = (inactiveDay) => {
    const user = JSON.parse(localStorage.getItem('user'));
    if (!user) {
      return;
    }

    fetch(`/api/inactive-days/${inactiveDay.id}`, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
      }
    })
    .then(response => {
      if (!response.ok) {
        throw new Error('Ошибка при активации дня');
      }
      return response.json();
    })
    .then(data => {
      console.log('День активирован:', data);
      fetchInactiveDays();
    })
    .catch(error => {
      console.error('Ошибка:', error);
    });
  };

  const handleEditPatient = () => {
    setIsEditingPatient(true);
    setEditingPatientData({
      name: selectedAppointment.patient_name,
      phone: selectedAppointment.patient_phone || '',
      birth_date: selectedAppointment.patient_birth_date || '',
      notes: selectedAppointment.patient_notes || ''
    });
  };

  const handleSavePatientEdit = () => {
    fetch(`/api/patients/${selectedAppointment.patient_id}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(editingPatientData)
    })
    .then(response => {
      if (!response.ok) {
        throw new Error('Ошибка при обновлении пациента');
      }
      return response.json();
    })
    .then(data => {
      console.log('Пациент обновлен:', data);
      fetchPatients();
      fetchAppointments();
      setIsEditingPatient(false);
      setEditingPatientData({
        name: '',
        phone: '',
        birth_date: '',
        notes: ''
      });
    })
    .catch(error => {
      console.error('Ошибка:', error);
    });
  };

  const handleCancelPatientEdit = () => {
    setIsEditingPatient(false);
    setEditingPatientData({
      name: '',
      phone: '',
      birth_date: '',
      notes: ''
    });
  };

  const handleEditAppointment = () => {
    setIsEditingAppointment(true);
    setEditingAppointmentData({
      appointment_time: selectedAppointment.appointment_time,
      direction: selectedAppointment.direction,
      location: selectedAppointment.location || 'tibbiyot_dunyosi',
      notes: selectedAppointment.notes || ''
    });
  };

  const handleSaveAppointmentEdit = () => {
    fetch(`/api/appointments/${selectedAppointment.id}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        patient_id: selectedAppointment.patient_id,
        doctor_id: selectedAppointment.doctor_id,
        appointment_date: selectedAppointment.appointment_date,
        appointment_time: editingAppointmentData.appointment_time,
        direction: editingAppointmentData.direction,
        location: editingAppointmentData.location,
        notes: editingAppointmentData.notes
      })
    })
    .then(response => {
      if (!response.ok) {
        throw new Error('Ошибка при обновлении записи');
      }
      return response.json();
    })
    .then(data => {
      console.log('Запись обновлена:', data);
      fetchAppointments();
      setIsEditingAppointment(false);
      setEditingAppointmentData({
        appointment_time: '',
        direction: '',
        location: '',
        notes: ''
      });
    })
    .catch(error => {
      console.error('Ошибка:', error);
    });
  };

  const handleCancelAppointmentEdit = () => {
    setIsEditingAppointment(false);
    setEditingAppointmentData({
      appointment_time: '',
      direction: '',
      location: '',
      notes: ''
    });
  };

  const handleDeleteAppointment = () => {
    fetch(`/api/appointments/${selectedAppointment.id}`, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
      }
    })
    .then(response => {
      if (!response.ok) {
        throw new Error('Ошибка при удалении записи');
      }
      return response.json();
    })
    .then(data => {
      console.log('Запись удалена:', data);
      fetchAppointments();
      closeModal();
    })
    .catch(error => {
      console.error('Ошибка:', error);
    });
  };

  const handleDeleteAppointmentFromList = (appointment, e) => {
    e.stopPropagation();
    fetch(`/api/appointments/${appointment.id}`, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
      }
    })
    .then(response => {
      if (!response.ok) {
        throw new Error('Ошибка при удалении записи');
      }
      return response.json();
    })
    .then(data => {
      console.log('Запись удалена из списка:', data);
      fetchAppointments();
    })
    .catch(error => {
      console.error('Ошибка:', error);
    });
  };

  const handleSendToTelegram = (date) => {
    const user = JSON.parse(localStorage.getItem('user'));
    if (!user) {
      return;
    }

    console.log('🚀 handleSendToTelegram вызван');
    console.log('📅 Полученная дата:', date);
    console.log('📅 Тип даты:', typeof date);
    console.log('📅 Дата instanceof Date:', date instanceof Date);

    // Исправляем проблему с часовым поясом
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const dateStr = `${year}-${month}-${day}`;
    
    console.log('📅 Отправляем дату в Telegram:', dateStr);
    console.log('📅 Исходная дата:', date);
    console.log('📅 Год:', year, 'Месяц:', month, 'День:', day);
    
    console.log('📤 Отправляем запрос на сервер с датой:', dateStr);
    
    // Проверяем, что дата корректна
    if (isNaN(year) || isNaN(month) || isNaN(day)) {
      console.error('❌ Ошибка: некорректная дата');
      return;
    }
    
    // Дополнительная проверка даты
    console.log('📅 Проверка даты:');
    console.log('  - Год:', year, '(корректный:', !isNaN(year), ')');
    console.log('  - Месяц:', month, '(корректный:', !isNaN(month), ')');
    console.log('  - День:', day, '(корректный:', !isNaN(day), ')');
    console.log('  - Итоговая дата:', dateStr);
    
    // Проверяем, что дата не пустая
    if (!dateStr || dateStr === 'NaN-NaN-NaN') {
      console.error('❌ Ошибка: пустая или некорректная дата');
      return;
    }
    
    fetch('/api/send-day-summary', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        date: dateStr,
        user_id: user.id
      })
    })
    .then(response => {
      console.log('📥 Получен ответ от сервера:', response.status, response.statusText);
      if (!response.ok) {
        throw new Error('Ошибка при отправке сводки');
      }
      return response.json();
    })
    .then(data => {
      console.log('✅ Сводка отправлена в Telegram:', data);
    })
    .catch(error => {
      console.error('❌ Ошибка:', error);
    });
  };

  // Функция для получения названия направления
  const getDirectionName = (direction) => {
    switch (direction) {
      case 'maestro':
        return 'Маэстро слуха';
      case 'vertigo':
        return 'Доктор Вертиго';
      default:
        return 'Неизвестно';
    }
  };

  // Функция для получения названия места проведения
  const getLocationName = (location) => {
    switch (location) {
      case 'tibbiyot_dunyosi':
        return 'Tibbiyot Dunyosi';
      case 'nii_otorinolaringologii':
        return 'НИИ Оториноларингологии';
      default:
        return 'Не указано';
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (isNewPatient) {
      // Создаем нового пациента, затем запись
      fetch('/api/patients', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(newPatientData)
      })
      .then(response => {
        if (!response.ok) {
          throw new Error('Ошибка при создании пациента');
        }
        return response.json();
      })
      .then(patientData => {
        // Создаем запись с новым пациентом
        const appointmentData = {
          patient_id: patientData.id,
          doctor_id: 1,
          appointment_date: getLocalDateString(selectedDate),
          appointment_time: formData.appointment_time,
          notes: formData.notes,
          direction: formData.direction,
          location: formData.location,
          created_by: 2
        };

        return fetch('/api/appointments', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(appointmentData)
        });
      })
      .then(response => {
        if (!response.ok) {
          throw new Error('Ошибка при создании записи');
        }
        return response.json();
      })
             .then(data => {
         console.log('Пациент и запись созданы:', data);
         fetchAppointments();
         fetchPatients();
         closeAddModal();
       })
       .catch(error => {
         console.error('Ошибка:', error);
       });
    } else {
      // Создаем только запись с существующим пациентом
      const appointmentData = {
        patient_id: formData.patient_id,
        doctor_id: 1,
        appointment_date: getLocalDateString(selectedDate),
        appointment_time: formData.appointment_time,
        notes: formData.notes,
        direction: formData.direction,
        location: formData.location,
        created_by: 2
      };

      fetch('/api/appointments', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(appointmentData)
      })
      .then(response => {
        if (!response.ok) {
          throw new Error('Ошибка при создании записи');
        }
        return response.json();
      })
             .then(data => {
         console.log('Запись создана:', data);
         fetchAppointments();
         closeAddModal();
       })
       .catch(error => {
         console.error('Ошибка:', error);
       });
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toLocaleDateString('ru-RU');
  };

  // Функция для получения локальной даты в формате YYYY-MM-DD (для Ташкента +5)
  const getLocalDateString = (date) => {
    if (!date) return '';
    // Создаем дату в локальном времени Ташкента
    const localDate = new Date(date.getTime() + (5 * 60 * 60 * 1000)); // +5 часов для Ташкента
    const year = localDate.getUTCFullYear();
    const month = String(localDate.getUTCMonth() + 1).padStart(2, '0');
    const day = String(localDate.getUTCDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  const days = getDaysInMonth(currentDate);
  const today = new Date();
  const isToday = (d) => d && d.getDate() === today.getDate() && d.getMonth() === today.getMonth() && d.getFullYear() === today.getFullYear();

  return (
    <div className="space-y-4 md:space-y-6">
      {/* Тулбар в стиле Defcon: белый фон, нижняя граница */}
      <div className="bg-white border-b border-[#e2e4e9] px-4 sm:px-6 lg:px-8 py-3 sm:py-4">
        <div className="flex flex-col gap-3 sm:flex-row sm:flex-wrap sm:items-center sm:justify-between">
          <h1 className="text-lg sm:text-xl font-semibold text-[#25272d] order-1">
            Календарь
          </h1>
          {/* Блок навигации: месяц, Сегодня, стрелки — как в макете Figma */}
          <div className="flex flex-wrap items-center gap-2 sm:gap-3 order-2">
            <span className="text-sm sm:text-base font-medium text-[#25272d] min-w-[140px] sm:min-w-[180px] capitalize">
              {currentDate.toLocaleDateString('ru-RU', { month: 'long', year: 'numeric' })}
            </span>
            <button
              type="button"
              onClick={() => setCurrentDate(new Date())}
              className="px-3 py-1.5 sm:px-4 sm:py-2 text-sm font-medium text-[#25272d] rounded-[4px] border border-[#e2e4e9] bg-white hover:bg-[#f5f5f6] transition-colors"
            >
              Сегодня
            </button>
            <div className="flex items-center rounded-[4px] border border-[#e2e4e9] overflow-hidden">
              <button
                type="button"
                onClick={() => setCurrentDate(new Date(currentDate.getFullYear(), currentDate.getMonth() - 1))}
                className="p-2 sm:p-2.5 hover:bg-[#f5f5f6] transition-colors text-[#8f929c] hover:text-[#25272d]"
                aria-label="Предыдущий месяц"
              >
                <ChevronLeft className="h-4 w-4 sm:h-5 sm:w-5" />
              </button>
              <button
                type="button"
                onClick={() => setCurrentDate(new Date(currentDate.getFullYear(), currentDate.getMonth() + 1))}
                className="p-2 sm:p-2.5 hover:bg-[#f5f5f6] transition-colors text-[#8f929c] hover:text-[#25272d]"
                aria-label="Следующий месяц"
              >
                <ChevronRight className="h-4 w-4 sm:h-5 sm:w-5" />
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Обёртка сетки с горизонтальным скроллом на мобильных */}
      <div className="bg-white rounded-lg sm:rounded-xl border border-[#e2e4e9] overflow-hidden">
        <div className="overflow-x-auto">
          <div className="min-w-[280px] grid grid-cols-7">
            {/* Заголовки дней недели — Defcon: светлый серый текст */}
            {['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Вс'].map((weekday, i) => (
              <div
                key={weekday}
                className={`bg-[#f5f5f6] px-1 sm:px-2 py-2 sm:py-3 text-center text-[10px] sm:text-xs font-medium uppercase tracking-wide text-[#8f929c] border-b border-r border-[#e2e4e9] ${i === 6 ? 'border-r-0 sm:border-r-0' : ''}`}
              >
                {weekday}
              </div>
            ))}
            {days.map((day, index) => {
              const dayAppointments = getAppointmentsForDate(day);
              const dayInactiveDays = getInactiveDaysForDate(day);
              const isInactive = dayInactiveDays.length > 0;
              const isCurrentDay = isToday(day);
              const isLastInRow = index % 7 === 6;

              return (
                <div
                  key={index}
                  className={`min-h-[72px] sm:min-h-[88px] md:min-h-[110px] p-1 sm:p-2 border-b border-r border-[#e2e4e9] bg-white ${
                    !isLastInRow ? '' : 'border-r-0'
                  } ${!day ? 'bg-[#fafafa]' : ''} ${day ? 'hover:bg-[#fafafa] cursor-pointer active:bg-[#f5f5f6]' : ''} ${
                    isInactive ? 'bg-red-50/90' : ''
                  } ${isCurrentDay ? 'ring-inset ring-2 ring-[#7f56d9] bg-[#f4f3ff]' : ''}`}
                  onClick={() => day && handleDayClick(day)}
                >
                  {day && (
                    <>
                      <div className={`text-[10px] sm:text-xs md:text-sm font-semibold mb-0.5 sm:mb-1 ${isCurrentDay ? 'text-[#5b3dd6]' : 'text-[#25272d]'}`}>
                        {day.getDate()}
                      </div>

                      {isInactive && (
                        <div className="mb-1 p-1 sm:p-1.5 bg-red-100 border border-red-200 rounded-[4px]">
                          <div className="flex items-center justify-between gap-0.5">
                            <span className="text-[10px] sm:text-xs font-medium text-red-700 truncate">Недоступен</span>
                            <button
                              type="button"
                              onClick={(e) => {
                                e.stopPropagation();
                                handleActivateDay(dayInactiveDays[0]);
                              }}
                              className="shrink-0 text-xs bg-green-600 text-white px-1.5 py-0.5 rounded hover:bg-green-700"
                              title="Активировать день"
                            >
                              ✅
                            </button>
                          </div>
                          {dayInactiveDays.map((inactiveDay, idx) => (
                            <div key={idx} className="text-[10px] sm:text-xs text-red-600 truncate mt-0.5">
                              {inactiveDay.reason}
                              {inactiveDay.custom_reason && ` — ${inactiveDay.custom_reason}`}
                            </div>
                          ))}
                        </div>
                      )}

                      <div className="space-y-0.5 sm:space-y-1">
                        {dayAppointments.length > 0 ? (
                          <>
                            {dayAppointments.slice(0, 3).map((apt, aptIndex) => {
                              const taskStyle =
                                apt.status === 'completed'
                                  ? 'border-l-[#12b76a] bg-[#ecfdf3]'
                                  : apt.status === 'cancelled'
                                  ? 'border-l-[#f04438] bg-[#fef3f2]'
                                  : apt.direction === 'maestro'
                                  ? 'border-l-[#3b82f6] bg-[#eff6ff]'
                                  : apt.direction === 'vertigo'
                                  ? 'border-l-[#10b981] bg-[#ecfdf5]'
                                  : 'border-l-[#74798b] bg-[#f5f5f6]';
                              return (
                                <div
                                  key={aptIndex}
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleAppointmentClick(apt);
                                  }}
                                  className={`text-[10px] sm:text-xs font-medium pl-1.5 sm:pl-2 pr-1 py-0.5 sm:py-1 rounded-r-[4px] border-l-[3px] cursor-pointer hover:opacity-90 truncate ${taskStyle}`}
                                >
                                  <span className="font-semibold text-[#25272d]">{apt.appointment_time}</span>
                                  <span className="hidden sm:inline text-[#8f929c] ml-1 truncate block">
                                    {apt.patient_name}
                                  </span>
                                </div>
                              );
                            })}
                            {dayAppointments.length > 3 && (
                              <button
                                type="button"
                                onClick={(e) => handleShowMoreClick(dayAppointments, day, e)}
                                className="w-full text-[10px] sm:text-xs font-medium text-[#8f929c] bg-[#f5f5f6] py-0.5 sm:py-1 rounded-[4px] text-center hover:bg-[#e2e4e9] transition-colors"
                              >
                                +{dayAppointments.length - 3} ещё
                              </button>
                            )}
                            {dayAppointments.length > 0 && (
                              <button
                                type="button"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleSendToTelegram(day);
                                }}
                                className="text-[10px] sm:text-xs text-[#3b82f6] font-medium py-0.5 hover:underline"
                                title="Отправить сводку в Telegram"
                              >
                                📱 TG
                              </button>
                            )}
                          </>
                        ) : (
                          <div className="flex flex-col items-center justify-center min-h-[28px] sm:min-h-[32px] gap-0.5">
                            <button
                              type="button"
                              className="p-1.5 text-[#8f929c] hover:text-[#25272d] hover:bg-[#f5f5f6] rounded-[4px] transition-colors"
                              onClick={(e) => {
                                e.stopPropagation();
                                handleDayClick(day);
                              }}
                              aria-label="Добавить запись"
                            >
                              <Plus className="h-3.5 w-3.5 sm:h-4 sm:w-4" />
                            </button>
                            <button
                              type="button"
                              className="text-red-400 hover:text-red-600 text-xs"
                              onClick={(e) => {
                                e.stopPropagation();
                                handleInactiveDayClick(day);
                              }}
                              title="Деактивировать день"
                            >
                              🚫
                            </button>
                          </div>
                        )}
                      </div>
                    </>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>

      {/* Легенда — компактно на мобильных */}
      <div className="bg-white rounded-lg sm:rounded-xl border border-[#e2e4e9] p-3 sm:p-4">
        <h3 className="text-xs sm:text-sm font-semibold text-[#25272d] mb-2 sm:mb-3">Направления</h3>
        <div className="flex flex-wrap gap-x-4 gap-y-2 sm:gap-4">
          <div className="flex items-center gap-1.5 sm:gap-2">
            <div className="w-2.5 h-2.5 sm:w-3 sm:h-3 rounded-[2px] bg-[#3b82f6]" aria-hidden />
            <span className="text-xs sm:text-sm text-[#25272d]">Маэстро слуха</span>
          </div>
          <div className="flex items-center gap-1.5 sm:gap-2">
            <div className="w-2.5 h-2.5 sm:w-3 sm:h-3 rounded-[2px] bg-[#10b981]" aria-hidden />
            <span className="text-xs sm:text-sm text-[#25272d]">Доктор Вертиго</span>
          </div>
          <div className="flex items-center gap-1.5 sm:gap-2">
            <div className="w-2.5 h-2.5 sm:w-3 sm:h-3 rounded-[2px] bg-[#12b76a]" aria-hidden />
            <span className="text-xs sm:text-sm text-[#25272d]">Завершено</span>
          </div>
          <div className="flex items-center gap-1.5 sm:gap-2">
            <div className="w-2.5 h-2.5 sm:w-3 sm:h-3 rounded-[2px] bg-[#f04438]" aria-hidden />
            <span className="text-xs sm:text-sm text-[#25272d]">Отменено / Недоступен</span>
          </div>
        </div>
      </div>

      {/* Модальное окно с деталями записи */}
      {showModal && selectedAppointment && (
        <div className="fixed inset-0 bg-gray-600 bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-4 md:p-6 w-full max-w-md mx-4 overflow-y-auto max-h-[90vh]">
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-lg font-semibold text-gray-900">Детали записи</h3>
              <button
                onClick={closeModal}
                className="text-gray-400 hover:text-gray-600"
              >
                <X className="h-6 w-6" />
              </button>
            </div>

            <div className="space-y-4">
              {/* Статус записи, направление и место проведения */}
              <div className="flex items-center space-x-3">
                <div className={`px-3 py-1 rounded-full text-sm font-medium ${
                  selectedAppointment.status === 'completed' ? 'bg-green-100 text-green-800' :
                  selectedAppointment.status === 'cancelled' ? 'bg-red-100 text-red-800' :
                  'bg-blue-100 text-blue-800'
                }`}>
                  {selectedAppointment.status === 'completed' ? 'Завершено' :
                   selectedAppointment.status === 'cancelled' ? 'Отменено' : 'Запланировано'}
                </div>
                <div className={`px-3 py-1 rounded-full text-sm font-medium ${
                  selectedAppointment.direction === 'maestro' ? 'bg-blue-100 text-blue-800' :
                  selectedAppointment.direction === 'vertigo' ? 'bg-green-100 text-green-800' :
                  'bg-gray-100 text-gray-800'
                }`}>
                  {getDirectionName(selectedAppointment.direction)}
                </div>
                <div className={`px-3 py-1 rounded-full text-sm font-medium ${
                  selectedAppointment.location === 'tibbiyot_dunyosi' ? 'bg-purple-100 text-purple-800' :
                  selectedAppointment.location === 'nii_otorinolaringologii' ? 'bg-orange-100 text-orange-800' :
                  'bg-gray-100 text-gray-800'
                }`}>
                  {getLocationName(selectedAppointment.location)}
                </div>
              </div>

              {/* Время и дата */}
              <div className="flex justify-between items-start">
                <div className="flex items-center space-x-2">
                  <CalendarIcon className="h-5 w-5 text-gray-400" />
                  <div>
                    {!isEditingAppointment ? (
                      <>
                        <div className="font-medium text-gray-900">
                          {selectedAppointment.appointment_time}
                        </div>
                        <div className="text-sm text-gray-500">
                          {formatDate(selectedAppointment.appointment_date)}
                        </div>
                      </>
                    ) : (
                      <div className="space-y-2">
                        <div>
                          <label className="block text-sm font-medium text-gray-700 mb-1">
                            Время *
                          </label>
                          <input
                            type="time"
                            value={editingAppointmentData.appointment_time}
                            onChange={(e) => setEditingAppointmentData({...editingAppointmentData, appointment_time: e.target.value})}
                            className="border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                            required
                          />
                        </div>
                        <div className="text-sm text-gray-500">
                          {formatDate(selectedAppointment.appointment_date)}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
                {!isEditingAppointment && (
                  <button
                    onClick={handleEditAppointment}
                    className="text-sm text-blue-600 hover:text-blue-800 font-medium"
                  >
                    Редактировать запись
                  </button>
                )}
              </div>

              {/* Информация о пациенте */}
              <div className="border-t pt-4">
                <div className="flex justify-between items-center mb-3">
                  <h4 className="font-medium text-gray-900 flex items-center">
                    <User className="h-5 w-5 mr-2 text-gray-400" />
                    Информация о пациенте
                  </h4>
                  {!isEditingPatient && (
                    <button
                      onClick={handleEditPatient}
                      className="text-sm text-blue-600 hover:text-blue-800 font-medium"
                    >
                      Редактировать
                    </button>
                  )}
                </div>
                
                {!isEditingPatient ? (
                  <div className="space-y-3">
                    <div>
                      <div className="text-sm font-medium text-gray-700">Имя</div>
                      <div className="text-base text-gray-900">{selectedAppointment.patient_name}</div>
                    </div>

                    {selectedAppointment.patient_phone && (
                      <div className="flex items-center space-x-2">
                        <Phone className="h-4 w-4 text-gray-400" />
                        <div>
                          <div className="text-sm font-medium text-gray-700">Телефон</div>
                          <div className="text-base text-gray-900">{selectedAppointment.patient_phone}</div>
                        </div>
                      </div>
                    )}

                                         {selectedAppointment.patient_birth_date && (
                       <div>
                         <div className="text-sm font-medium text-gray-700">Год рождения</div>
                         <div className="text-base text-gray-900">{selectedAppointment.patient_birth_date}</div>
                       </div>
                     )}

                    {selectedAppointment.patient_notes && (
                      <div>
                        <div className="text-sm font-medium text-gray-700">Заметки о пациенте</div>
                        <div className="text-sm text-gray-900 bg-gray-50 p-2 rounded">
                          {selectedAppointment.patient_notes}
                        </div>
                      </div>
                    )}
                  </div>
                ) : (
                  <div className="space-y-4">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        Имя пациента *
                      </label>
                      <input
                        type="text"
                        value={editingPatientData.name}
                        onChange={(e) => setEditingPatientData({...editingPatientData, name: e.target.value})}
                        className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                        placeholder="ФИО пациента"
                        required
                      />
                    </div>
                    
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        Телефон
                      </label>
                      <input
                        type="tel"
                        value={editingPatientData.phone}
                        onChange={(e) => setEditingPatientData({...editingPatientData, phone: e.target.value})}
                        className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                        placeholder="+7-999-123-45-67"
                      />
                    </div>
                    
                                         <div>
                       <label className="block text-sm font-medium text-gray-700 mb-1">
                         Год рождения
                       </label>
                       <input
                         type="number"
                         min="1900"
                         max="2025"
                         value={editingPatientData.birth_date}
                         onChange={(e) => setEditingPatientData({...editingPatientData, birth_date: e.target.value})}
                         className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                         placeholder="Например: 1990"
                       />
                     </div>
                    
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        Заметки о пациенте
                      </label>
                      <textarea
                        value={editingPatientData.notes}
                        onChange={(e) => setEditingPatientData({...editingPatientData, notes: e.target.value})}
                        rows={2}
                        className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                        placeholder="Дополнительная информация о пациенте..."
                      />
                    </div>

                    <div className="flex space-x-3 pt-2">
                      <button
                        type="button"
                        onClick={handleSavePatientEdit}
                        className="flex-1 px-3 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 text-sm"
                      >
                        Сохранить
                      </button>
                      <button
                        type="button"
                        onClick={handleCancelPatientEdit}
                        className="flex-1 px-3 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50 text-sm"
                      >
                        Отмена
                      </button>
                    </div>
                  </div>
                )}
              </div>

              {/* Направление и заметки */}
              {!isEditingAppointment ? (
                <>
                  {/* Направление */}
                  <div className="border-t pt-4">
                    <div className="text-sm font-medium text-gray-700 mb-2">Направление</div>
                    <div className={`inline-block px-3 py-1 rounded-full text-sm font-medium ${
                      selectedAppointment.direction === 'maestro' ? 'bg-blue-100 text-blue-800' :
                      selectedAppointment.direction === 'vertigo' ? 'bg-green-100 text-green-800' :
                      'bg-gray-100 text-gray-800'
                    }`}>
                      {getDirectionName(selectedAppointment.direction)}
                    </div>
                  </div>

                  {/* Заметки */}
                  {selectedAppointment.notes && (
                    <div className="border-t pt-4">
                      <div className="text-sm font-medium text-gray-700 mb-2">Заметки</div>
                      <div className="text-sm text-gray-900 bg-gray-50 p-3 rounded">
                        {selectedAppointment.notes}
                      </div>
                    </div>
                  )}
                </>
              ) : (
                <div className="space-y-4 border-t pt-4">
                  {/* Направление */}
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Направление *
                    </label>
                    <div className="space-y-2">
                      <label className="flex items-center">
                        <input
                          type="radio"
                          name="edit-direction"
                          value="maestro"
                          checked={editingAppointmentData.direction === 'maestro'}
                          onChange={(e) => setEditingAppointmentData({...editingAppointmentData, direction: e.target.value})}
                          className="mr-2"
                        />
                        <span className="text-sm font-medium text-gray-700">Маэстро слуха</span>
                        <div className="ml-2 w-4 h-4 bg-blue-500 rounded"></div>
                      </label>
                      <label className="flex items-center">
                        <input
                          type="radio"
                          name="edit-direction"
                          value="vertigo"
                          checked={editingAppointmentData.direction === 'vertigo'}
                          onChange={(e) => setEditingAppointmentData({...editingAppointmentData, direction: e.target.value})}
                          className="mr-2"
                        />
                        <span className="text-sm font-medium text-gray-700">Доктор Вертиго</span>
                        <div className="ml-2 w-4 h-4 bg-green-500 rounded"></div>
                      </label>
                    </div>
                  </div>

                  {/* Место приема */}
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Место приема *
                    </label>
                    <div className="space-y-2">
                      <label className="flex items-center">
                        <input
                          type="radio"
                          name="edit-location"
                          value="tibbiyot_dunyosi"
                          checked={editingAppointmentData.location === 'tibbiyot_dunyosi'}
                          onChange={(e) => setEditingAppointmentData({...editingAppointmentData, location: e.target.value})}
                          className="mr-2"
                        />
                        <span className="text-sm font-medium text-gray-700">Tibbiyot Dunyosi</span>
                        <div className="ml-2 w-4 h-4 bg-purple-500 rounded"></div>
                      </label>
                      <label className="flex items-center">
                        <input
                          type="radio"
                          name="edit-location"
                          value="nii_otorinolaringologii"
                          checked={editingAppointmentData.location === 'nii_otorinolaringologii'}
                          onChange={(e) => setEditingAppointmentData({...editingAppointmentData, location: e.target.value})}
                          className="mr-2"
                        />
                        <span className="text-sm font-medium text-gray-700">НИИ Оториноларингологии</span>
                        <div className="ml-2 w-4 h-4 bg-orange-500 rounded"></div>
                      </label>
                    </div>
                  </div>

                  {/* Заметки */}
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Заметки
                    </label>
                    <textarea
                      value={editingAppointmentData.notes}
                      onChange={(e) => setEditingAppointmentData({...editingAppointmentData, notes: e.target.value})}
                      rows={3}
                      className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                      placeholder="Дополнительная информация..."
                    />
                  </div>

                  <div className="flex space-x-3 pt-2">
                    <button
                      type="button"
                      onClick={handleSaveAppointmentEdit}
                      className="flex-1 px-3 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 text-sm"
                    >
                      Сохранить
                    </button>
                    <button
                      type="button"
                      onClick={handleCancelAppointmentEdit}
                      className="flex-1 px-3 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50 text-sm"
                    >
                      Отмена
                    </button>
                  </div>
                </div>
              )}

              {/* Кнопки действий */}
              {!isEditingPatient && !isEditingAppointment && (
                <div className="flex space-x-3 pt-4 border-t">
                  <button
                    onClick={closeModal}
                    className="flex-1 px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50"
                  >
                    Закрыть
                  </button>
                  <button
                    onClick={handleDeleteAppointment}
                    className="flex-1 px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700"
                  >
                    Удалить
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      {/* Модальное окно для добавления записи */}
      {showAddModal && selectedDate && (
        <div className="fixed inset-0 bg-gray-600 bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-4 md:p-6 w-full max-w-md mx-4 overflow-y-auto max-h-[90vh]">
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-lg font-semibold text-gray-900">Новая запись</h3>
              <button
                onClick={closeAddModal}
                className="text-gray-400 hover:text-gray-600"
              >
                <X className="h-6 w-6" />
              </button>
            </div>

            <form onSubmit={handleSubmit} className="space-y-4">
              {/* Дата */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Дата
                </label>
                <div className="flex items-center space-x-2">
                  <CalendarIcon className="h-5 w-5 text-gray-400" />
                  <span className="text-gray-900">
                    {selectedDate.toLocaleDateString('ru-RU')}
                  </span>
                </div>
              </div>

                             {/* Переключатель пациента */}
               <div>
                 <div className="flex items-center space-x-4 mb-4">
                   <label className="flex items-center">
                     <input
                       type="radio"
                       checked={!isNewPatient}
                       onChange={() => setIsNewPatient(false)}
                       className="mr-2"
                     />
                     <span className="text-sm font-medium text-gray-700">Выбрать существующего пациента</span>
                   </label>
                   <label className="flex items-center">
                     <input
                       type="radio"
                       checked={isNewPatient}
                       onChange={() => setIsNewPatient(true)}
                       className="mr-2"
                     />
                     <span className="text-sm font-medium text-gray-700">Создать нового пациента</span>
                   </label>
                 </div>

                 {!isNewPatient ? (
                   /* Выбор существующего пациента */
                   <div>
                     <label className="block text-sm font-medium text-gray-700 mb-2">
                       Пациент *
                     </label>
                     <select
                       value={formData.patient_id}
                       onChange={(e) => setFormData({...formData, patient_id: e.target.value})}
                       className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                       required
                     >
                       <option value="">Выберите пациента</option>
                       {patients.map(patient => (
                         <option key={patient.id} value={patient.id}>
                           {patient.name}
                         </option>
                       ))}
                     </select>
                   </div>
                 ) : (
                   /* Форма нового пациента */
                   <div className="space-y-4">
                     <div>
                       <label className="block text-sm font-medium text-gray-700 mb-2">
                         Имя пациента *
                       </label>
                       <input
                         type="text"
                         value={newPatientData.name}
                         onChange={(e) => setNewPatientData({...newPatientData, name: e.target.value})}
                         className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                         placeholder="ФИО пациента"
                         required
                       />
                     </div>
                     
                     <div>
                       <label className="block text-sm font-medium text-gray-700 mb-2">
                         Телефон
                       </label>
                       <input
                         type="tel"
                         value={newPatientData.phone}
                         onChange={(e) => setNewPatientData({...newPatientData, phone: e.target.value})}
                         className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                         placeholder="+7-999-123-45-67"
                       />
                     </div>
                     
                                           <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                          Год рождения
                        </label>
                        <input
                          type="number"
                          min="1900"
                          max="2025"
                          value={newPatientData.birth_date}
                          onChange={(e) => setNewPatientData({...newPatientData, birth_date: e.target.value})}
                          className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                          placeholder="Например: 1990"
                        />
                      </div>
                     
                     <div>
                       <label className="block text-sm font-medium text-gray-700 mb-2">
                         Заметки о пациенте
                       </label>
                       <textarea
                         value={newPatientData.notes}
                         onChange={(e) => setNewPatientData({...newPatientData, notes: e.target.value})}
                         rows={2}
                         className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                         placeholder="Дополнительная информация о пациенте..."
                       />
                     </div>
                   </div>
                 )}
               </div>

              {/* Направление */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Направление *
                </label>
                <div className="space-y-2">
                  <label className="flex items-center">
                    <input
                      type="radio"
                      name="direction"
                      value="maestro"
                      checked={formData.direction === 'maestro'}
                      onChange={(e) => setFormData({...formData, direction: e.target.value})}
                      className="mr-2"
                    />
                    <span className="text-sm font-medium text-gray-700">Маэстро слуха</span>
                    <div className="ml-2 w-4 h-4 bg-blue-500 rounded"></div>
                  </label>
                  <label className="flex items-center">
                    <input
                      type="radio"
                      name="direction"
                      value="vertigo"
                      checked={formData.direction === 'vertigo'}
                      onChange={(e) => setFormData({...formData, direction: e.target.value})}
                      className="mr-2"
                    />
                    <span className="text-sm font-medium text-gray-700">Доктор Вертиго</span>
                    <div className="ml-2 w-4 h-4 bg-green-500 rounded"></div>
                  </label>
                </div>
              </div>

              {/* Место приема */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Место приема *
                </label>
                <div className="space-y-2">
                  <label className="flex items-center">
                    <input
                      type="radio"
                      name="location"
                      value="tibbiyot_dunyosi"
                      checked={formData.location === 'tibbiyot_dunyosi'}
                      onChange={(e) => setFormData({...formData, location: e.target.value})}
                      className="mr-2"
                    />
                    <span className="text-sm font-medium text-gray-700">Tibbiyot Dunyosi</span>
                    <div className="ml-2 w-4 h-4 bg-purple-500 rounded"></div>
                  </label>
                  <label className="flex items-center">
                    <input
                      type="radio"
                      name="location"
                      value="nii_otorinolaringologii"
                      checked={formData.location === 'nii_otorinolaringologii'}
                      onChange={(e) => setFormData({...formData, location: e.target.value})}
                      className="mr-2"
                    />
                    <span className="text-sm font-medium text-gray-700">НИИ Оториноларингологии</span>
                    <div className="ml-2 w-4 h-4 bg-orange-500 rounded"></div>
                  </label>
                </div>
              </div>

              {/* Время */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Время *
                </label>
                <div className="flex items-center space-x-2">
                  <Clock className="h-5 w-5 text-gray-400" />
                  <input
                    type="time"
                    value={formData.appointment_time}
                    onChange={(e) => setFormData({...formData, appointment_time: e.target.value})}
                    className="flex-1 border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                    required
                  />
                </div>
              </div>

              {/* Заметки */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Заметки
                </label>
                <textarea
                  value={formData.notes}
                  onChange={(e) => setFormData({...formData, notes: e.target.value})}
                  rows={3}
                  className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                  placeholder="Дополнительная информация..."
                />
              </div>

              {/* Кнопки */}
              <div className="flex space-x-3 pt-4">
                <button
                  type="button"
                  onClick={closeAddModal}
                  className="flex-1 px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50"
                >
                  Отмена
                </button>
                                 <button
                   type="submit"
                   className="flex-1 px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
                 >
                   {isNewPatient ? 'Создать пациента и запись' : 'Создать запись'}
                 </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Модальное окно со списком всех пациентов на день */}
      {showListModal && selectedDayAppointments.length > 0 && (
        <div className="fixed inset-0 bg-gray-600 bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-6 w-full max-w-2xl mx-4 max-h-[80vh] overflow-y-auto">
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-lg font-semibold text-gray-900">
                Все записи на {selectedDate ? formatDate(getLocalDateString(selectedDate)) : formatDate(selectedDayAppointments[0]?.appointment_date)}
              </h3>
              <button
                onClick={closeListModal}
                className="text-gray-400 hover:text-gray-600"
              >
                <X className="h-6 w-6" />
              </button>
            </div>

            <div className="space-y-3">
              {selectedDayAppointments.map((appointment, index) => (
                <div
                  key={index}
                  className={`p-4 rounded-lg border cursor-pointer transition-all hover:scale-105 ${
                    appointment.status === 'completed' ? 'bg-green-50 border-green-200 hover:bg-green-100' :
                    appointment.status === 'cancelled' ? 'bg-red-50 border-red-200 hover:bg-red-100' :
                    appointment.direction === 'maestro' ? 'bg-blue-50 border-blue-200 hover:bg-blue-100' :
                    appointment.direction === 'vertigo' ? 'bg-green-50 border-green-200 hover:bg-green-100' :
                    'bg-gray-50 border-gray-200 hover:bg-gray-100'
                  }`}
                  onClick={() => {
                    setSelectedAppointment(appointment);
                    setShowModal(true);
                    closeListModal();
                  }}
                >
                  <div className="flex justify-between items-start">
                    <div className="flex-1">
                      <div className="flex items-center space-x-3 mb-2">
                        <div className={`px-2 py-1 rounded-full text-xs font-medium ${
                          appointment.status === 'completed' ? 'bg-green-100 text-green-800' :
                          appointment.status === 'cancelled' ? 'bg-red-100 text-red-800' :
                          'bg-blue-100 text-blue-800'
                        }`}>
                          {appointment.status === 'completed' ? 'Завершено' :
                           appointment.status === 'cancelled' ? 'Отменено' : 'Запланировано'}
                        </div>
                        <div className={`px-2 py-1 rounded-full text-xs font-medium ${
                          appointment.direction === 'maestro' ? 'bg-blue-100 text-blue-800' :
                          appointment.direction === 'vertigo' ? 'bg-green-100 text-green-800' :
                          'bg-gray-100 text-gray-800'
                        }`}>
                          {getDirectionName(appointment.direction)}
                        </div>
                      </div>
                      
                      <div className="flex items-center space-x-2 mb-1">
                        <Clock className="h-4 w-4 text-gray-400" />
                        <span className="font-medium text-gray-900">
                          {appointment.appointment_time}
                        </span>
                      </div>
                      
                      <div className="flex items-center space-x-2">
                        <User className="h-4 w-4 text-gray-400" />
                        <span className="text-gray-900 font-medium">
                          {appointment.patient_name}
                        </span>
                      </div>

                      {appointment.patient_phone && (
                        <div className="flex items-center space-x-2 mt-1">
                          <Phone className="h-4 w-4 text-gray-400" />
                          <span className="text-sm text-gray-600">
                            {appointment.patient_phone}
                          </span>
                        </div>
                      )}

                      {appointment.notes && (
                        <div className="mt-2 text-sm text-gray-600">
                          <span className="font-medium">Заметки:</span> {appointment.notes}
                        </div>
                      )}
                    </div>
                    <button
                      onClick={(e) => handleDeleteAppointmentFromList(appointment, e)}
                      className="ml-4 p-2 text-red-600 hover:text-red-800 hover:bg-red-50 rounded transition-colors"
                      title="Удалить запись"
                    >
                      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                      </svg>
                    </button>
                  </div>
                </div>
              ))}
            </div>

            <div className="mt-6 pt-4 border-t">
              <div className="flex justify-between items-center">
                <div className="text-sm text-gray-600">
                  <span className="font-medium">Всего записей:</span> {selectedDayAppointments.length}
                </div>
                <button
                  onClick={() => {
                    console.log('🚀 Кнопка "Отправить в Telegram" нажата');
                    console.log('📅 selectedDate:', selectedDate);
                    console.log('📅 selectedDate тип:', typeof selectedDate);
                    console.log('📅 selectedDate instanceof Date:', selectedDate instanceof Date);
                    handleSendToTelegram(selectedDate);
                  }}
                  className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors flex items-center space-x-2"
                >
                  <span>📱</span>
                  <span>Отправить в Telegram</span>
                </button>
              </div>
              <div className="text-sm text-gray-600 mt-1">
                <span className="font-medium">Маэстро слуха:</span> {selectedDayAppointments.filter(apt => apt.direction === 'maestro').length}
              </div>
              <div className="text-sm text-gray-600">
                <span className="font-medium">Доктор Вертиго:</span> {selectedDayAppointments.filter(apt => apt.direction === 'vertigo').length}
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Модальное окно для деактивации дня */}
      {showInactiveModal && (
        <div className="fixed inset-0 bg-gray-600 bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-4 md:p-6 w-full max-w-md mx-4 overflow-y-auto max-h-[90vh]">
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-lg font-semibold text-gray-900">Деактивировать день</h3>
              <button
                onClick={closeInactiveModal}
                className="text-gray-400 hover:text-gray-600"
              >
                <X className="h-6 w-6" />
              </button>
            </div>

            <form onSubmit={handleInactiveSubmit} className="space-y-4">
              {/* Дата */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Дата
                </label>
                <div className="flex items-center space-x-2">
                  <CalendarIcon className="h-5 w-5 text-gray-400" />
                  <span className="text-gray-900">
                    {inactiveFormData.inactive_date ? new Date(inactiveFormData.inactive_date).toLocaleDateString('ru-RU') : ''}
                  </span>
                </div>
              </div>

              {/* Тип причины */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Тип причины
                </label>
                <div className="space-y-2">
                  <label className="flex items-center">
                    <input
                      type="radio"
                      name="reasonType"
                      checked={!inactiveFormData.useCustomReason}
                      onChange={() => setInactiveFormData({...inactiveFormData, useCustomReason: false})}
                      className="mr-2"
                    />
                    <span className="text-sm text-gray-700">Выбрать из списка</span>
                  </label>
                  <label className="flex items-center">
                    <input
                      type="radio"
                      name="reasonType"
                      checked={inactiveFormData.useCustomReason}
                      onChange={() => setInactiveFormData({...inactiveFormData, useCustomReason: true})}
                      className="mr-2"
                    />
                    <span className="text-sm text-gray-700">Написать произвольный комментарий</span>
                  </label>
                </div>
              </div>

              {/* Причина из списка */}
              {!inactiveFormData.useCustomReason && (
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Причина недоступности *
                  </label>
                  <select
                    value={inactiveFormData.reason}
                    onChange={(e) => setInactiveFormData({...inactiveFormData, reason: e.target.value})}
                    className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                    required={!inactiveFormData.useCustomReason}
                  >
                    <option value="">Выберите причину</option>
                    <option value="Отпуск">Отпуск</option>
                    <option value="Болезнь">Болезнь</option>
                    <option value="Командировка">Командировка</option>
                    <option value="Выходной день">Выходной день</option>
                    <option value="Праздничный день">Праздничный день</option>
                    <option value="Техническое обслуживание">Техническое обслуживание</option>
                    <option value="Совещание">Совещание</option>
                    <option value="Конференция">Конференция</option>
                    <option value="Другое">Другое</option>
                  </select>
                </div>
              )}

              {/* Произвольный комментарий */}
              {inactiveFormData.useCustomReason && (
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Произвольный комментарий *
                  </label>
                  <textarea
                    value={inactiveFormData.custom_reason}
                    onChange={(e) => setInactiveFormData({...inactiveFormData, custom_reason: e.target.value})}
                    rows={3}
                    className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                    placeholder="Укажите произвольный комментарий о причине недоступности..."
                    required={inactiveFormData.useCustomReason}
                  />
                </div>
              )}

              {/* Дополнительная информация (только для выбранных причин) */}
              {!inactiveFormData.useCustomReason && (
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Дополнительная информация
                  </label>
                  <textarea
                    value={inactiveFormData.custom_reason}
                    onChange={(e) => setInactiveFormData({...inactiveFormData, custom_reason: e.target.value})}
                    rows={3}
                    className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                    placeholder="Укажите дополнительную информацию о причине недоступности..."
                  />
                </div>
              )}

              {/* Кнопки */}
              <div className="flex space-x-3 pt-4">
                <button
                  type="button"
                  onClick={closeInactiveModal}
                  className="flex-1 px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50"
                >
                  Отмена
                </button>
                <button
                  type="submit"
                  className="flex-1 px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700"
                >
                  Деактивировать день
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default Calendar; 